import { GetFullUserType } from '@orbit/api-types'
import { getDeviceContext } from '@lib/analytics'
import api from '@lib/api'
import { queryKeys } from '@lib/queryKeys'
import { useQuery } from '@tanstack/react-query'

interface CheckQrTokenResponse {
	token: string
	user?: GetFullUserType
	expiry: number
}

export function useCheckQrToken(token: string | undefined, enabled: boolean) {
	return useQuery<CheckQrTokenResponse>({
		queryKey: queryKeys.qrTokenCheck(token),
		queryFn: async () => {
			// The poll carries the device context so the server can record the
			// sign-in event on the one call that resolves the scan.
			const { data } = await api.post<CheckQrTokenResponse>('auth/qr-code/check', {
				token,
				analytics: getDeviceContext(),
			})
			return data
		},
		enabled: enabled && !!token,
		refetchInterval: 2000, // Check every 2 seconds
		retry: false,
	})
}
